/* Fetch the latest artifact via: atlas fd get-artifact recent-work-service */

const _default_1: {
	hydrators: {
		AssetsObject: {
			hydratorPaths: {
				containers: string[];
				icon: string[];
				id: string[];
				key: string[];
				name: string[];
				url: string[];
			};
			staticFallbacks: {
				icon: string;
			};
		};
		AssetsObjectType: {
			hydratorPaths: {
				containers: string[];
				icon: string[];
				id: string[];
				key: string[];
				name: string[];
				url: string[];
			};
			staticFallbacks: {
				icon: string;
			};
		};
		AssetsSchema: {
			hydratorPaths: {
				id: string[];
				key: string[];
				name: string[];
				url: string[];
			};
			staticFallbacks: {
				icon: string;
			};
		};
		BitbucketPullRequest: {
			hydratorPaths: {
				id: string[];
				key: string[];
				name: string[];
				url: string[];
			};
			staticFallbacks: {
				icon: string;
			};
		};
		CompassComponent: {
			hydratorPaths: {
				icon: string[];
				id: string[];
				key: string[];
				name: string[];
				url: string[];
			};
			staticFallbacks: {
				icon: string;
			};
		};
		ConfluenceBlogPost: {
			hydratorPaths: {
				containers: string[];
				id: string[];
				localResourceId: string[];
				name: string[];
				url: string[];
			};
			staticFallbacks: {
				icon: string;
			};
		};
		ConfluenceComment: {
			hydratorPaths: {
				containers: string[];
				deduplicateId: string[];
				id: string[];
				name: string[];
				url: string[];
			};
			staticFallbacks: {
				confluenceBlogIcon: string;
				confluencePageIcon: string;
				confluenceWhiteboardIcon: string;
				icon: string;
			};
		};
		ConfluenceDatabase: {
			hydratorPaths: {
				containers: string[];
				id: string[];
				localResourceId: string[];
				name: string[];
				url: string[];
			};
			staticFallbacks: {
				icon: string;
			};
		};
		ConfluenceEmbed: {
			hydratorPaths: {
				containers: string[];
				id: string[];
				localResourceId: string[];
				name: string[];
				url: string[];
			};
			staticFallbacks: {
				icon: string;
			};
		};
		ConfluenceFooterComment: {
			hydratorPaths: {
				containers: string[];
				deduplicateId: string[];
				id: string[];
				name: string[];
				url: string[];
			};
			staticFallbacks: {
				confluenceBlogIcon: string;
				confluencePageIcon: string;
				confluenceWhiteboardIcon: string;
				icon: string;
			};
		};
		ConfluenceInlineComment: {
			hydratorPaths: {
				containers: string[];
				deduplicateId: string[];
				id: string[];
				name: string[];
				url: string[];
			};
			staticFallbacks: {
				confluenceBlogIcon: string;
				confluencePageIcon: string;
				confluenceWhiteboardIcon: string;
				icon: string;
			};
		};
		ConfluencePage: {
			hydratorPaths: {
				containers: string[];
				id: string[];
				localResourceId: string[];
				name: string[];
				subtype: string[];
				url: string[];
			};
			staticFallbacks: {
				confluenceLiveDocIcon: string;
				icon: string;
			};
		};
		ConfluenceWhiteboard: {
			hydratorPaths: {
				containers: string[];
				id: string[];
				localResourceId: string[];
				name: string[];
				url: string[];
			};
			staticFallbacks: {
				icon: string;
			};
		};
		DevOpsDesign: {
			hydratorPaths: {
				id: string[];
				name: string[];
				url: string[];
			};
			staticFallbacks: {
				icon: string;
			};
		};
		DevOpsDocument: {
			hydratorPaths: {
				icon: string[];
				id: string[];
				name: string[];
				url: string[];
			};
		};
		DevOpsPullRequestDetails: {
			hydratorPaths: {
				containers: string[];
				id: string[];
				key: string[];
				name: string[];
				url: string[];
			};
			staticFallbacks: {
				icon: string;
			};
		};
		ExternalDocument: {
			hydratorPaths: {
				containers: string[];
				creator: string[];
				id: string[];
				key: string[];
				name: string[];
				providerId: string[];
				subtype: string[];
				url: string[];
			};
			staticFallbacks: {
				icon: string;
				thirdPartyIconPath: string;
			};
		};
		ExternalRemoteLink: {
			hydratorPaths: {
				containers: string[];
				creator: string[];
				id: string[];
				name: string[];
				providerId: string[];
				subtype: string[];
				url: string[];
			};
			staticFallbacks: {
				icon: string;
				thirdPartyIconPath: string;
			};
		};
		JiraIssue: {
			hydratorPaths: {
				containers: string[];
				icon: string[];
				id: string[];
				key: string[];
				name: string[];
				objectTypeName: string[];
				statusColor: string[];
				statusValue: string[];
				url: string[];
			};
		};
		JiraPlatformComment: {
			hydratorPaths: {
				containers: string[];
				deduplicateId: string[];
				icon: string[];
				id: string[];
				key: string[];
				name: string[];
				objectTypeName: string[];
				url: string[];
			};
		};
		JiraServiceManagementComment: {
			hydratorPaths: {
				containers: string[];
				deduplicateId: string[];
				icon: string[];
				id: string[];
				key: string[];
				name: string[];
				objectTypeName: string[];
				url: string[];
			};
		};
		LoomVideo: {
			hydratorPaths: {
				id: string[];
				key: string[];
				name: string[];
				url: string[];
			};
			staticFallbacks: {
				icon: string;
			};
		};
		MercuryFocusArea: {
			hydratorPaths: {
				icon: string[];
				id: string[];
				key: string[];
				name: string[];
				url: string[];
			};
			staticFallbacks: {
				icon: string;
			};
		};
		MercuryPortfolio: {
			hydratorPaths: {
				id: string[];
				key: string[];
				name: string[];
				url: string[];
			};
			staticFallbacks: {
				icon: string;
			};
		};
		TownsquareComment: {
			hydratorPaths: {
				deduplicateId: string[];
				icon: string[];
				id: string[];
				key: string[];
				name: string[];
				url: string[];
			};
		};
		TownsquareGoal: {
			hydratorPaths: {
				icon: string[];
				id: string[];
				key: string[];
				name: string[];
				statusScore: string[];
				statusValue: string[];
				url: string[];
			};
		};
		TownsquareProject: {
			hydratorPaths: {
				icon: string[];
				id: string[];
				key: string[];
				name: string[];
				statusValue: string[];
				url: string[];
			};
		};
		TrelloBoard: {
			hydratorPaths: {
				containers: string[];
				deduplicateId: string[];
				id: string[];
				name: string[];
				url: string[];
			};
			staticFallbacks: {
				icon: string;
			};
		};
		TrelloCard: {
			hydratorPaths: {
				containers: string[];
				deduplicateId: string[];
				id: string[];
				name: string[];
				url: string[];
			};
			staticFallbacks: {
				icon: string;
			};
		};
	};
	localization: {
		eventTypes: {
			clicked: {
				absolute: string;
				multiAbsolute: string;
				multiRelative: string;
				multiStandalone: string;
				relative: string;
				standalone: string;
			};
			commented: {
				absolute: string;
				multiAbsolute: string;
				multiRelative: string;
				multiStandalone: string;
				relative: string;
				standalone: string;
			};
			created: {
				absolute: string;
				multiAbsolute: string;
				multiRelative: string;
				multiStandalone: string;
				relative: string;
				standalone: string;
			};
			edited: {
				absolute: string;
				multiAbsolute: string;
				multiRelative: string;
				multiStandalone: string;
				relative: string;
				standalone: string;
			};
			published: {
				absolute: string;
				multiAbsolute: string;
				multiRelative: string;
				multiStandalone: string;
				relative: string;
				standalone: string;
			};
			'sl-clicked': {
				absolute: string;
				multiAbsolute: string;
				multiRelative: string;
				multiStandalone: string;
				relative: string;
				standalone: string;
			};
			'sl-viewed': {
				absolute: string;
				multiAbsolute: string;
				multiRelative: string;
				multiStandalone: string;
				relative: string;
				standalone: string;
			};
			updated: {
				absolute: string;
				multiAbsolute: string;
				multiRelative: string;
				multiStandalone: string;
				relative: string;
				standalone: string;
			};
			viewed: {
				absolute: string;
				multiAbsolute: string;
				multiRelative: string;
				multiStandalone: string;
				relative: string;
				standalone: string;
			};
		};
	};
	queryFragments: string;
} = {
	localization: {
		eventTypes: {
			commented: {
				absolute: 'You commented on {absoluteTime}',
				relative: 'You commented {relativeTime}',
				standalone: 'You commented',
				multiAbsolute: 'Commented on {absoluteTime}',
				multiRelative: 'Commented {relativeTime}',
				multiStandalone: 'Commented',
			},
			created: {
				absolute: 'You created on {absoluteTime}',
				relative: 'You created {relativeTime}',
				standalone: 'You created',
				multiAbsolute: 'Created on {absoluteTime}',
				multiRelative: 'Created {relativeTime}',
				multiStandalone: 'Created',
			},
			edited: {
				absolute: 'You edited on {absoluteTime}',
				relative: 'You edited {relativeTime}',
				standalone: 'You edited',
				multiAbsolute: 'Edited on {absoluteTime}',
				multiRelative: 'Edited {relativeTime}',
				multiStandalone: 'Edited',
			},
			published: {
				absolute: 'You published on {absoluteTime}',
				relative: 'You published {relativeTime}',
				standalone: 'You published',
				multiAbsolute: 'Published on {absoluteTime}',
				multiRelative: 'Published {relativeTime}',
				multiStandalone: 'Published',
			},
			updated: {
				absolute: 'You updated on {absoluteTime}',
				relative: 'You updated {relativeTime}',
				standalone: 'You updated',
				multiAbsolute: 'Updated on {absoluteTime}',
				multiRelative: 'Updated {relativeTime}',
				multiStandalone: 'Updated',
			},
			viewed: {
				absolute: 'You viewed on {absoluteTime}',
				relative: 'You viewed {relativeTime}',
				standalone: 'You viewed',
				multiAbsolute: 'Viewed on {absoluteTime}',
				multiRelative: 'Viewed {relativeTime}',
				multiStandalone: 'Viewed',
			},
			'sl-viewed': {
				absolute: 'You viewed on {absoluteTime}',
				relative: 'You viewed {relativeTime}',
				standalone: 'You viewed',
				multiAbsolute: 'Viewed on {absoluteTime}',
				multiRelative: 'Viewed {relativeTime}',
				multiStandalone: 'Viewed',
			},
			clicked: {
				absolute: 'You viewed on {absoluteTime}',
				relative: 'You viewed {relativeTime}',
				standalone: 'You viewed',
				multiAbsolute: 'Viewed on {absoluteTime}',
				multiRelative: 'Viewed {relativeTime}',
				multiStandalone: 'Viewed',
			},
			'sl-clicked': {
				absolute: 'You viewed on {absoluteTime}',
				relative: 'You viewed {relativeTime}',
				standalone: 'You viewed',
				multiAbsolute: 'Viewed on {absoluteTime}',
				multiRelative: 'Viewed {relativeTime}',
				multiStandalone: 'Viewed',
			},
		},
	},
	hydrators: {
		TownsquareGoal: {
			hydratorPaths: {
				id: ['id'],
				key: ['key'],
				name: ['name'],
				url: ['url'],
				icon: ['iconData'],
				statusValue: ['status.value'],
				statusScore: ['status.score'],
			},
		},
		TownsquareProject: {
			hydratorPaths: {
				id: ['id'],
				key: ['key'],
				name: ['name'],
				url: ['url'],
				icon: ['iconData'],
				statusValue: ['state.value'],
			},
		},
		TownsquareComment: {
			hydratorPaths: {
				id: ['id'],
				key: ['container.key'],
				name: ['container.name'],
				url: ['container.url'],
				icon: ['container.iconData'],
				deduplicateId: ['container.id'],
			},
		},
		ConfluencePage: {
			hydratorPaths: {
				id: ['id'],
				name: ['title'],
				localResourceId: ['pageId'],
				subtype: ['subtype'],
				url: ['links.base', 'links.webUi'],
				containers: ['space.name'],
			},
			staticFallbacks: {
				icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
				confluenceLiveDocIcon:
					'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/live-doc.svg',
			},
		},
		ConfluenceBlogPost: {
			hydratorPaths: {
				id: ['id'],
				name: ['title'],
				localResourceId: ['blogPostId'],
				url: ['links.base', 'links.webUi'],
				containers: ['space.name'],
			},
			staticFallbacks: {
				icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/blogpost.svg',
			},
		},
		ConfluenceWhiteboard: {
			hydratorPaths: {
				id: ['id'],
				name: ['title'],
				localResourceId: ['whiteboardId'],
				url: ['links.base', 'links.webUi'],
				containers: ['space.name'],
			},
			staticFallbacks: {
				icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/whiteboard.svg',
			},
		},
		ConfluenceDatabase: {
			hydratorPaths: {
				id: ['id'],
				name: ['title'],
				localResourceId: ['databaseId'],
				url: ['links.base', 'links.webUi'],
				containers: ['space.name'],
			},
			staticFallbacks: {
				icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/database.svg',
			},
		},
		ConfluenceEmbed: {
			hydratorPaths: {
				id: ['id'],
				name: ['title'],
				localResourceId: ['embedId'],
				url: ['links.base', 'links.webUi'],
				containers: ['space.name'],
			},
			staticFallbacks: {
				icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/embed.svg',
			},
		},
		ConfluenceComment: {
			hydratorPaths: {
				id: ['id'],
				name: ['container.title'],
				url: ['links.base', 'links.webUi'],
				containers: ['container.space.name'],
				deduplicateId: ['container.id'],
			},
			staticFallbacks: {
				icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
				confluenceBlogIcon:
					'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/blogpost.svg',
				confluencePageIcon:
					'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
				confluenceWhiteboardIcon:
					'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/whiteboard.svg',
			},
		},
		ConfluenceFooterComment: {
			hydratorPaths: {
				id: ['id'],
				name: ['container.title'],
				url: ['links.base', 'links.webUi'],
				containers: ['container.space.name'],
				deduplicateId: ['container.id'],
			},
			staticFallbacks: {
				icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
				confluenceBlogIcon:
					'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/blogpost.svg',
				confluencePageIcon:
					'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
				confluenceWhiteboardIcon:
					'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/whiteboard.svg',
			},
		},
		ConfluenceInlineComment: {
			hydratorPaths: {
				id: ['id'],
				name: ['container.title'],
				url: ['links.base', 'links.webUi'],
				containers: ['container.space.name'],
				deduplicateId: ['container.id'],
			},
			staticFallbacks: {
				icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
				confluenceBlogIcon:
					'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/blogpost.svg',
				confluencePageIcon:
					'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
				confluenceWhiteboardIcon:
					'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/whiteboard.svg',
			},
		},
		JiraIssue: {
			hydratorPaths: {
				id: ['id'],
				name: ['fieldsById.edges(node.fieldId: "summary").node.text'],
				url: ['webUrl'],
				containers: ['fieldsById.edges(node.fieldId: "project").node.project.name'],
				objectTypeName: ['fieldsById.edges(node.fieldId: "issuetype").node.issueType.name'],
				icon: ['fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.medium'],
				key: ['key'],
				statusValue: ['fieldsByIdOrAlias(fieldId: "status").status.name'],
				statusColor: ['fieldsByIdOrAlias(fieldId: "status").status.statusCategory.colorName'],
			},
		},
		JiraPlatformComment: {
			hydratorPaths: {
				id: ['commentId'],
				name: ['issue.fieldsById.edges(node.fieldId: "summary").node.text'],
				url: ['webUrl'],
				containers: ['issue.fieldsById.edges(node.fieldId: "project").node.project.name'],
				objectTypeName: ['issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.name'],
				icon: ['issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.medium'],
				key: ['issue.key'],
				deduplicateId: ['issue.id'],
			},
		},
		JiraServiceManagementComment: {
			hydratorPaths: {
				id: ['commentId'],
				name: ['issue.fieldsById.edges(node.fieldId: "summary").node.text'],
				url: ['webUrl'],
				containers: ['issue.fieldsById.edges(node.fieldId: "project").node.project.name'],
				objectTypeName: ['issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.name'],
				icon: ['issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.medium'],
				key: ['issue.key'],
				deduplicateId: ['issue.id'],
			},
		},
		TrelloBoard: {
			hydratorPaths: {
				id: ['id'],
				name: ['boardName'],
				url: ['boardUrl'],
				containers: ['workspace.displayName'],
				deduplicateId: ['objectId'],
			},
			staticFallbacks: {
				icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/trello/board.svg',
			},
		},
		TrelloCard: {
			hydratorPaths: {
				id: ['id'],
				name: ['cardName'],
				url: ['cardUrl'],
				containers: ['list.name', 'list.board.name'],
				deduplicateId: ['objectId'],
			},
			staticFallbacks: {
				icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/trello/card.svg',
			},
		},
		DevOpsDocument: {
			hydratorPaths: { id: ['id'], name: ['displayName'], url: ['webUrl'], icon: ['type.iconUrl'] },
		},
		DevOpsPullRequestDetails: {
			hydratorPaths: {
				id: ['id'],
				name: ['title'],
				url: ['url'],
				containers: ['repositoryName'],
				key: ['providerName'],
			},
			staticFallbacks: {
				icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/graph/pull-request.svg',
			},
		},
		DevOpsDesign: {
			hydratorPaths: { id: ['id'], name: ['displayName'], url: ['webUrl'] },
			staticFallbacks: {
				icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/graph/design.svg',
			},
		},
		ExternalDocument: {
			hydratorPaths: {
				id: ['thirdPartyId'],
				name: ['displayName'],
				url: ['url'],
				subtype: ['type.category'],
				key: ['parent.displayName'],
				containers: ['createdBy.thirdPartyUser.name'],
				creator: ['createdBy.thirdPartyUser.name'],
				providerId: ['provider.providerId'],
			},
			staticFallbacks: {
				icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/graph/document.svg',
				thirdPartyIconPath:
					'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/third-party-logos/{replaceProductName}/default.svg',
			},
		},
		ExternalRemoteLink: {
			hydratorPaths: {
				id: ['thirdPartyId'],
				name: ['displayName'],
				url: ['url'],
				subtype: ['category'],
				containers: ['createdBy.thirdPartyUser.name'],
				creator: ['createdBy.thirdPartyUser.name'],
				providerId: ['provider.providerId'],
			},
			staticFallbacks: {
				icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/graph/document.svg',
				thirdPartyIconPath:
					'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/third-party-logos/{replaceProductName}/default.svg',
			},
		},
		MercuryFocusArea: {
			hydratorPaths: {
				id: ['id'],
				name: ['name'],
				url: ['url'],
				key: ['focusAreaType.name'],
				icon: ['icon.url'],
			},
			staticFallbacks: {
				icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/mercury/focus-area.svg',
			},
		},
		MercuryPortfolio: {
			hydratorPaths: { id: ['id'], name: ['name'], url: ['url'], key: ['label'] },
			staticFallbacks: {
				icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/mercury/view.svg',
			},
		},
		CompassComponent: {
			hydratorPaths: {
				id: ['id'],
				name: ['name'],
				url: ['url'],
				icon: ['typeMetadata.iconUrl'],
				key: ['typeMetadata.name'],
			},
			staticFallbacks: {
				icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/compass/logo.svg',
			},
		},
		BitbucketPullRequest: {
			hydratorPaths: {
				id: ['id'],
				name: ['pullRequestTitle'],
				url: ['href'],
				key: ['pullRequestTitle'],
			},
			staticFallbacks: {
				icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/bitbucket/logo.svg',
			},
		},
		LoomVideo: {
			hydratorPaths: { id: ['id'], name: ['name'], url: ['loomUrl'], key: ['owner.name'] },
			staticFallbacks: {
				icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/loom/logo.svg',
			},
		},
		AssetsObject: {
			hydratorPaths: {
				id: ['id'],
				name: ['label'],
				key: ['displayTypename'],
				url: ['links.web'],
				icon: ['avatar.url48'],
				containers: ['objectType.schema.name'],
			},
			staticFallbacks: {
				icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/assets/logo.svg',
			},
		},
		AssetsObjectType: {
			hydratorPaths: {
				id: ['id'],
				name: ['assetsObjectTypeName'],
				key: ['displayTypename'],
				url: ['links.web'],
				icon: ['assetsObjectTypeIcon.url48'],
				containers: ['schema.assetsSchemaName'],
			},
			staticFallbacks: {
				icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/assets/logo.svg',
			},
		},
		AssetsSchema: {
			hydratorPaths: {
				id: ['id'],
				name: ['assetsSchemaName'],
				key: ['displayTypename'],
				url: ['links.web'],
			},
			staticFallbacks: {
				icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/assets/logo.svg',
			},
		},
	},
	queryFragments:
		'\n\n  fragment townsquareGoal on TownsquareGoal {\n    id\n    key\n    name\n    url\n    iconData\n    status {\n      value\n      score\n    }\n  }\n\n\n  fragment townsquareProject on TownsquareProject {\n    id\n    key\n    name\n    url\n    iconData\n    state {\n      value\n    }\n  }\n\n\n  fragment townsquareComment on TownsquareComment {\n    id\n    url\n    container {\n      __typename\n      ...townsquareGoal\n      ...townsquareProject\n    }\n  }\n\n\n  fragment confluencePage on ConfluencePage {\n    id\n    title\n    pageId\n    subtype\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceBlogPost on ConfluenceBlogPost {\n    id\n    title\n    blogPostId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceWhiteboard on ConfluenceWhiteboard {\n    id\n    title\n    whiteboardId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceDatabase on ConfluenceDatabase {\n    id\n    title\n    databaseId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceEmbed on ConfluenceEmbed {\n    id\n    title\n    embedId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceComment on ConfluenceComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n      ...confluenceWhiteboard\n    }\n  }\n\n\n  fragment confluenceFooterComment on ConfluenceFooterComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n      ...confluenceWhiteboard\n    }\n  }\n\n\n  fragment confluenceInlineComment on ConfluenceInlineComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n      ...confluenceWhiteboard\n    }\n  }\n\n\nfragment jiraIssue on JiraIssue {\n  id\n  key\n  webUrl\n  fieldsById(ids: ["summary", "issuetype", "project"]) {\n    edges {\n      node {\n        __typename\n        fieldId\n        ...jiraSingleLineTextField\n        ...jiraIssueTypeField\n        ...jiraProjectField\n      }\n    }\n  }\n  fieldsByIdOrAlias(idsOrAliases: ["status"]) @optIn(to: "JiraIssueFieldsByIdOrAlias") {\n    __typename\n    fieldId\n    ...jiraStatusField\n  }\n}\nfragment jiraSingleLineTextField on JiraSingleLineTextField {\n  text\n}\nfragment jiraIssueTypeField on JiraIssueTypeField {\n  issueType {\n    name\n    avatar {\n      medium\n    }\n  }\n}\nfragment jiraProjectField on JiraProjectField {\n  project {\n    name\n  }\n}\nfragment jiraStatusField on JiraStatusField {\n  status {\n    name\n    statusCategory {\n      colorName\n    }\n  }\n}\n\n\nfragment jiraPlatformComment on JiraPlatformComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\n\nfragment jiraServiceManagementComment on JiraServiceManagementComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\n\nfragment trelloBoard on TrelloBoard {\n  id\n  objectId\n  boardName: name\n  boardUrl: url\n  workspace {\n    id\n    displayName\n  }\n}\n\n\nfragment trelloCard on TrelloCard {\n  id\n  objectId\n  cardName: name\n  cardUrl: url\n  list {\n    id\n    name\n    board @optIn(to: "TrelloListBoard") {\n      id\n      name\n    }\n  }\n}\n\n\n        fragment graphDevOpsDocument on DevOpsDocument {\n          id\n          displayName\n          webUrl: url\n          type {\n            iconUrl\n          }\n        }\n    \n\n        fragment graphExternalDocument on ExternalDocument {\n            id\n            type {\n                category\n            }\n            displayName\n            parent @optIn(to: "ExternalDataDepotQueryV2"){\n                ...on ExternalDocument {\n                    displayName\n                }\n            }\n            url\n            provider {\n                providerId\n            }\n            createdBy {\n                thirdPartyUser {\n                    name\n                }\n            }\n            thirdPartyId\n        }\n    \n\nfragment graphPullRequest on DevOpsPullRequestDetails {\n  id\n  title\n  url\n  repositoryName\n  providerName\n}\n\n\nfragment graphDesign on DevOpsDesign {\n  id\n  displayName\n  webUrl: url\n}\n\n\n        fragment graphExternalRemoteLink on ExternalRemoteLink {\n            id\n            displayName\n            category\n            createdBy {\n                thirdPartyUser {\n                    name\n                }\n            }\n            url\n            provider {\n                providerId\n            }\n            thirdPartyId\n        }\n    \n\n    fragment mercuryFocusArea on MercuryFocusArea {\n        id\n        name\n        url\n        focusAreaType {\n            name\n        }\n        icon {\n            url\n        }\n    }\n    \n\n    fragment mercuryPortfolio on MercuryPortfolio {\n        id\n        name\n        url\n        label\n    }\n    \n\nfragment compassComponent on CompassComponent {\n  id\n  name\n  url\n  typeMetadata {\n    iconUrl\n    name\n  }\n}\n\n\nfragment bitbucketPullRequest on BitbucketPullRequest {\n  id\n  pullRequestTitle: title\n  href\n  author {\n    picture\n  }\n}\n\n\nfragment loomVideo on LoomVideo {\n  id\n  name\n  loomUrl: url\n  owner {\n    name\n    picture\n  }\n}\n\n\n    fragment assetsObject on AssetsObject {\n      id\n      label\n      objectKey\n      links {\n        web\n      }\n      avatar {\n        url48\n      }\n      objectType {\n        name\n        schema {\n          name\n        }\n      }\n      displayTypename @optIn(to: "AssetsApFields")\n    }\n\n\n    fragment assetsObjectType on AssetsObjectType {\n      id\n      assetsObjectTypeName: name\n      links {\n        web\n      }\n      assetsObjectTypeIcon: icon {\n        url48\n      }\n      schema {\n        id\n        assetsSchemaName: name\n      }\n      displayTypename @optIn(to: "AssetsApFields")\n    }\n\n\n    fragment assetsSchema on AssetsSchema {\n      id\n      assetsSchemaKey: key\n      assetsSchemaName: name\n      links {\n        web\n      }\n      displayTypename @optIn(to: "AssetsApFields")\n    }\n\nfragment activityItemEdge on ActivityItemEdge {\n  cursor\n  node {\n    id\n    object {\n      id\n      type\n      product\n      subProduct\n      rootContainerId\n      contributors {\n        profile {\n          name\n          picture\n          accountId\n        }\n      }\n      data {\n        __typename\n\t...townsquareGoal\n\t...townsquareProject\n\t...townsquareComment\n\t...confluencePage\n\t...confluenceBlogPost\n\t...confluenceWhiteboard\n\t...confluenceDatabase\n\t...confluenceEmbed\n\t...confluenceComment\n\t...confluenceFooterComment\n\t...confluenceInlineComment\n\t...jiraIssue\n\t...jiraPlatformComment\n\t...jiraServiceManagementComment\n\t...trelloBoard\n\t...trelloCard\n\t...graphDevOpsDocument\n\t...graphExternalDocument\n\t...graphPullRequest\n\t...graphDesign\n\t...graphExternalRemoteLink\n\t...mercuryFocusArea\n\t...mercuryPortfolio\n\t...compassComponent\n\t...bitbucketPullRequest\n\t...loomVideo\n\t...assetsObject\n\t...assetsObjectType\n\t...assetsSchema\n      }\n    }\n    event {\n      id\n      timestamp\n      eventType\n      actor {\n        name\n        picture\n        accountId\n      }\n    }\n  }\n}\nfragment activityItemConnection on ActivityConnection {\n  edges {\n    ...activityItemEdge\n  }\n}\n\n',
};
export default _default_1;
